import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/emc2groep.webp';
import screenshot_target from '../../../images/letterfunnel/dennisnieuwenhuys.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Dennis Nieuwenhuys"
      firstname="Dennis"
      companyname="E=MC2 Groep"
      competition="Drees & Sommer en Gispen"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/dennisnieuwenhuys.js